/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface VideoContentCategoryParentInfos {
  /** 홈케어 콘텐츠 카테고리 고유ID */
  _id?: string;
  /** 홈케어 콘텐츠 카테고리명 */
  categoryName?: string;
  /** 병원ID */
  hospitalID?: string;
  /** 정렬순서 */
  sortNum?: number;
  /** 상위 카테고리 ID */
  parentCategoryIDs?: VideoContentCategoryNameTopParent[];
  /** 카테고리 대 여부 */
  isTop?: boolean;
  /** 카테고리 중 여부 */
  isParent?: boolean;
  /** 숨김 처리 여부 */
  isHidden?: boolean;
  /** 카테고리별 기초 콘텐츠 여부 */
  isBasic?: boolean;
  /** 홈케어 콘텐츠 카테고리에 대한 설명 (oo의원 전용 콘텐츠 등) */
  description?: string;
  /** 카테고리의 명칭 (부위, 난이도, ...) */
  typeName?: string;
  /** 컨디셔닝 영상 여부 */
  isConditioning?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface VideoContentCategoryNameTopParent {
  /** 홈케어 콘텐츠 카테고리 고유ID */
  _id?: string;
  /** 운동콘텐츠 카테고리명 */
  categoryName?: string;
  /** 카테고리 대 여부 */
  isTop?: boolean;
  /** 카테고리 중 여부 */
  isParent?: boolean;
}

export interface ApiVideocontentcategoryElFindParams {
  /** (optional) 홈케어 콘텐츠 카테고리 ID 배열 */
  "_id[]"?: string[];
  /** (required) 대 카테고리 검색 여부 boolean flag */
  isTop: boolean;
  /** 중 카테고리 검색 여부 boolean flag */
  isParent?: boolean;
  /** (optional) 부모 홈케어 콘텐츠 카테고리 ID */
  "parentCategoryIDs[]"?: string[];
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
}

export type ApiVideocontentcategoryElFindData = ApiResponse & {
  data: VideoContentCategoryParentInfos[];
};

export interface ApiVideocontentcategoryElFindOneParams {
  /** (required) 홈케어 콘텐츠 카테고리 고유 ID */
  _id: string;
}

export type ApiVideocontentcategoryElFindOneData = ApiResponse & {
  data: VideoContentCategoryParentInfos;
};

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description - isTop 이 true 일 경우, 카테고리 대 조회(통증 및 재활, 병원별 전용 콘텐츠...) - isTop 이 false 이고 isParent 이 true이며, parentCategoryIDs가 있는 경우, 해당 부모 카테고리에 속한 카테고리 조회 - isTop 이 false 이고 isParent 이 false일 경우, 소 카테고리 조회
     *
     * @tags V3-VideoContentCategory
     * @name ApiVideocontentcategoryElFind
     * @summary 홈케어 콘텐츠 카테고리 목록 조회
     * @request GET:/v3/api/videocontentcategory/el/find
     * @secure
     * @response `200` `ApiVideocontentcategoryElFindData` \[\{VideoContentCategory\}\] 홈케어 콘텐츠 카테고리 컬렉션 객체 배열
     */
    apiVideocontentcategoryElFind: (query: ApiVideocontentcategoryElFindParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentcategoryElFindData, any>({
        path: `/v3/api/videocontentcategory/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-VideoContentCategory
     * @name ApiVideocontentcategoryElFindOne
     * @summary 홈케어 콘텐츠 카테고리 목록 조회
     * @request GET:/v3/api/videocontentcategory/el/find/one
     * @secure
     * @response `200` `ApiVideocontentcategoryElFindOneData` \{VideoContentCategory\} 홈케어 콘텐츠 카테고리 컬렉션 객체
     */
    apiVideocontentcategoryElFindOne: (query: ApiVideocontentcategoryElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiVideocontentcategoryElFindOneData, any>({
        path: `/v3/api/videocontentcategory/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
